"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TrackSession = function TrackSession(_ref) {
  var size = _ref.size,
      color = _ref.color;
  return _react["default"].createElement(_SvgIcon["default"], {
    title: "track-session",
    size: size
  }, _react["default"].createElement("path", {
    fill: color,
    d: "M4 0c1.66 0 3 1 3 3 0 1.24-.86 2.76-2.58 4.57l-.24.25c-.09.08-.21.1-.3.04l-.06-.04-.24-.25C1.86 5.76 1 4.24 1 3c0-2 1.34-3 3-3zm0 1a2 2 0 100 4 2 2 0 000-4zm.27.64l1.18 1.68.01.04c.09.18.02.4-.14.48l-1.17.62c-.1.05-.2.05-.3 0l-1.18-.63-.04-.02a.37.37 0 01-.06-.5l1.16-1.67.03-.04.04-.03.04-.03a.32.32 0 01.43.1zM4 2.06L3 3.48 4 4l1-.53-1-1.42z"
  }));
};

TrackSession.defaultProps = {
  size: 8,
  color: '#444'
};
var _default = TrackSession;
exports["default"] = _default;